class CandidateJobMatchesWorkflowActionsModalController {
    constructor() {
    }
    $onInit() {
        this.action = this.resolve.action;
        this.jobId = this.resolve.jobId;
        this.clientOrBuName = this.resolve.clientOrBuName;
        this.clientOrBuId = this.resolve.clientOrBuId;
        this.isSharedRequisition = this.resolve.isSharedRequisition;
        this.corporateCompanyId = this.resolve.corporateCompanyId;
        this.corporateCompanyName = this.resolve.corporateCompanyName;
        this.jobMatchDetailsArray = this.resolve.jobMatchDetailsArray;
        this.lastAddedCandidateSourceTypeId = this.resolve.lastAddedCandidateSourceTypeId;
        this.statusType = this.resolve.statusType;
        this.resumeRequiredForWorkflow = this.resolve.resumeRequiredForWorkflow;
        this.formalizeActivityPayload = this.resolve.formalizeActivityPayload;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        this.jobMatchIdArray = [];
        this.candidateIds = '';
        this.assessmentType = '';
        this.assessmentSendMode = '';
        this.modalHeading = '';
        this.isRefreshDone = true;
        angular.forEach(this.jobMatchDetailsArray, (val, key) => {
            this.jobMatchIdArray.push(val.jobMatchId);
        });
        if (this.action == 'addCandidates') {
            this.modalHeading = 'Add New Candidates';
        }
        else if (this.action == 'jobProfile') {
            this.modalHeading = 'Job Profile';
        }
        else if (this.action == 'addCandidatesFromJobBoards') {
            this.modalHeading = 'Get Candidates From Job Boards';
        }
        else if (this.action == 'associateCandidates') {
            this.modalHeading = 'Associate Existing Candidates';
        }
        else if (this.action == 'release') {
            this.modalHeading = 'Release';
        }
        else if (this.action == 'notInterested') {
            this.modalHeading = 'Not Interested';
        }
        else if (this.action == 'delete') {
            this.modalHeading = 'Delete Job Matches';
        }
        else if (this.action == 'assignRecruiter') {
            this.modalHeading = 'Assign Recruiter';
        }
        else if (this.action == 'sendTechAssessment') {
            this.modalHeading = 'Send/Resend Technical Assessment';
            this.assessmentType = 'Technical';
            this.assessmentSendMode = 'send';
        }
        else if (this.action == 'sendValueAssessment') {
            this.modalHeading = 'Send/Resend Value Assessment';
            this.assessmentType = 'Value';
            this.assessmentSendMode = 'send';
        }
        else if (this.action == 'cancelTechAssessment') {
            this.modalHeading = 'Cancel Technical Assessment';
            this.assessmentType = 'Technical';
        }
        else if (this.action == 'cancelValueAssessment') {
            this.modalHeading = 'Cancel Value Assessment';
            this.assessmentType = 'Value';
        }
        else if (this.action == 'compareCandidates') {
            this.modalHeading = 'Candidate Comparison';
            angular.forEach(this.jobMatchDetailsArray, (val, key) => {
                this.candidateIds += (this.candidateIds == '' ? val.candidateId : ',' + val.candidateId);
            });
        }
    }
    closeModal() {
        if ((this.action == 'addCandidates' || this.action == 'addCandidatesFromJobBoards' || this.action == 'associateCandidates')
            && !this.isRefreshDone) {
            this.refresh();
        }
        else {
            this.modalInstance.close(this.callbackObject);
        }
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
    refresh() {
        this.callbackObject.callbackType = 'refresh';
        this.isRefreshDone = true;
        this.modalInstance.close(this.callbackObject);
    }
    candidateProcessedCallback() {
        this.isRefreshDone = false;
    }
}
// import * as TEMPLATE from './candidate-job-matches-workflow-actions-modal.html';
import * as TEMPLATE from 'raw-loader!./candidate-job-matches-workflow-actions-modal.html';
export const CandidateJobMatchesWorkflowActionsModalComponent = {
    selector: 'candidateJobMatchesWorkflowActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: CandidateJobMatchesWorkflowActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchesWorkflowActionsModal/candidate-job-matches-workflow-actions-modal.html'
    }
};
//# sourceMappingURL=candidate-job-matches-workflow-actions-modal.component.js.map